<template>
  <div>
    <b-row class="m-auto">
      <b-col>
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                Campos obligatorios <strong :style="{ color: colorAsterisco }">*</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <b-row class="pt-4">
                  <b-col lg="5">
                    <validation-provider
                      name="Número de identificación tributaria"
                      :rules="{ required: true, numeric: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company1" label-for="input-company1"
                      :invalid-feedback="validationContext.errors[0]">
                      <template v-slot:label>
                        Número de identificación tributaria: <strong :style="{ color: colorAsterisco }">*</strong>
                      </template>
                      <b-form-input id="input-company1" v-model="form.nit" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese el número de identificación tributaria sin dígito de verificación"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col md="2">
                    <validation-provider
                      name="DV"
                      :rules="{ numeric: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company2" label="DV:" label-for="input-company2"
                      :invalid-feedback="validationContext.errors[0]">
                      <b-form-input id="input-company2" v-model="dv" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" readOnly placeholder="0"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="5">
                    <validation-provider
                      name="Tipo de persona"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-group-company3" label-for="input-company3" :invalid-feedback="validationContext.errors[0]" >
                        <template v-slot:label>
                          Tipo de persona: <strong :style="{ color: colorAsterisco }">*</strong>
                        </template>
                        <b-form-select id="input-company3" v-model="form.typePerson" :options="identificationOptions" required
                        :state="getValidationState(validationContext)"></b-form-select>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row v-if="form.typePerson == 1">
                  <b-col lg="3">
                    <validation-provider
                      name="primer nombre"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company9" label-for="input-company9"
                      :invalid-feedback="validationContext.errors[0]">
                      <template v-slot:label>
                        Primer nombre: <strong :style="{ color: colorAsterisco }">*</strong>
                      </template>
                      <b-form-input id="input-company9" v-model="form.firstName" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese el primer nombre"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3">
                    <validation-provider
                      name="segundo nombre"
                      :rules="{ required: false }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company10" label="Segundo nombre:" label-for="input-company10"
                      :invalid-feedback="validationContext.errors[0]">
                      <b-form-input id="input-company10" v-model="form.secondName" autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese el segundo nombre"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3">
                    <validation-provider
                      name="primer apellido"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company11" label-for="input-company11"
                      :invalid-feedback="validationContext.errors[0]">
                      <template v-slot:label>
                        Primer apellido: <strong :style="{ color: colorAsterisco }">*</strong>
                      </template>
                      <b-form-input id="input-company11" v-model="form.firstLastName" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese el primer apellido"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3">
                    <validation-provider
                      name="segundo apellido"
                      :rules="{ required: false }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company12" label="Segundo apellido:" label-for="input-company12"
                      :invalid-feedback="validationContext.errors[0]">
                      <b-form-input id="input-company12" v-model="form.secondLastName" autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese el segundo apellido"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">
                    <validation-provider
                      name="Razón social"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company4" label-for="input-company4"
                      :invalid-feedback="validationContext.errors[0]">
                      <template v-slot:label>
                        Nombre comercial / Razón social: <strong :style="{ color: colorAsterisco }">*</strong>
                      </template>
                      <b-form-input id="input-company4" v-model="form.name" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese la razón social"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="6">
                    <validation-provider
                      name="Correo electrónico"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company5" label-for="input-company5"
                      :invalid-feedback="validationContext.errors[0]">
                      <template v-slot:label>
                        Correo electrónico: <strong :style="{ color: colorAsterisco }">*</strong>
                      </template>
                      <b-form-input id="input-company5" v-model="form.email" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="example@mail.com"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">
                    <validation-provider
                      name="Dirección"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                    <b-form-group id="input-group-company6" label-for="input-company6"
                      :invalid-feedback="validationContext.errors[0]">
                      <template v-slot:label>
                        Dirección: <strong :style="{ color: colorAsterisco }">*</strong>
                      </template>
                      <b-form-input id="input-company6" v-model="form.address" required autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)" placeholder="Ingrese la dirección"></b-form-input>
                    </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3">
                    <validation-provider
                      name="Departamento"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-group-company7" label-for="input-company7" :invalid-feedback="validationContext.errors[0]" >
                        <template v-slot:label>
                          Departamento: <strong :style="{ color: colorAsterisco }">*</strong>
                        </template>
                        <b-form-select id="input-company7" v-model="form.idDepartment" :options="departments" required
                        :state="getValidationState(validationContext)"></b-form-select>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3">
                    <validation-provider
                      name="Municipio"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-group-company8" label-for="input-company8" :invalid-feedback="validationContext.errors[0]" >
                        <template v-slot:label>
                          Municipio: <strong :style="{ color: colorAsterisco }">*</strong>
                        </template>
                        <b-form-select id="input-company8" v-model="form.idMunicipality" :options="municipalities" required
                        :state="getValidationState(validationContext)"></b-form-select>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="4">
                <b-row class="justify-content-center">
                  <b-col>
                    <img
                      :src="form.logo"
                      @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                      width="175" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;">
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-file
                        @change="onFileChange"
                        placeholder="Seleccione una imagen"
                        drop-placeholder="Suelta la imagen aquí"
                        accept="image/jpeg, image/png, image/gif"
                        browse-text="Buscar imagen"
                        v-model="file"
                      ></b-form-file>
                      <p class="text-secondary">La imagen no debe superar las 5MB</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import { validateDV } from '@/services/utilities'
// import Swal from 'sweetalert2'

// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 6000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })

export default {
  name: 'basicSettings',
  components: {},
  data() {
    return {
      file: null,
      image: null,
      fileUrl: '',
      identificationOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 1, text: 'Persona natural' },
        { value: 2, text: 'Persona jurídica' },
      ],
      accessToken: '',
      departments: [],
      municipalities: [
        { value: null, text: 'Seleccione una opción' },
      ],
      invalid: false,
      form: {
        logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/PlaceholderLC.png/1024px-PlaceholderLC.png',
        nit: '',
        idDepartment: null,
        idMunicipality: null,
        typePerson: null,
        name: '',
        email: '',
        address: '',
        firstName: '',
        secondName: '',
        firstLastName: '',
        secondLastName: '',
      },
      colorAsterisco: 'red',
    }
  },
  computed: {
    ...mapState(['user']),
    dv: {
      get () {
        return validateDV(this.form.nit)
      },
      set (newValue) {
        return newValue
      },
    },
  },
  created () {
    // TODO Una vez implementado el get de school en la v2 de la api
    // se puede hacer un promise.all como dice esta pagina: https://blog.logrocket.com/using-axios-all-make-concurrent-requests/
    apiClient2.get('/departments').then(data => {
      this.departments = data.data.data.map((x) => {
        return {
          value: x.id,
          text: x.name,
        }
      })
      this.departments.unshift({ value: null, text: 'Seleccione una opción' })
    }).catch(error => {
      console.log(error)
      this.$notification.error({
        message: 'Ooops ocurrió un error',
        description: error.response.data.msg,
      })
    })
    apiClient2.get('/company/1').then(data => {
      this.form.nit = data.data.data.nit
      this.form.typePerson = data.data.data.typePerson
      this.form.name = data.data.data.name
      this.form.email = data.data.data.email
      this.form.address = data.data.data.address
      this.form.idDepartment = data.data.data.idDepartment
      this.form.idMunicipality = data.data.data.idMunicipality
      this.form.firstName = data.data.data.firstName
      this.form.secondName = data.data.data.secondName
      this.form.firstLastName = data.data.data.firstLastName
      this.form.secondLastName = data.data.data.secondLastName
      if (data.data.data.logo !== null && data.data.data.logo !== '') {
        this.form.logo = data.data.data.logo
      }
    }).catch(error => {
      console.log(error)
      this.$notification.error({
        message: 'Ooops ocurrió un error',
        description: error.response.data.msg,
      })
    })
  },
  methods: {
    onFileChange(e) {
      this.image = e.target.files[0]
      this.fileUrl = URL.createObjectURL(this.image)
      this.form.logo = this.fileUrl
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    saveImage(idSchool) {
      if (this.file) { // Sube la foto de perfil
        if (this.file.size > 5000000) {
          return Promise.reject(new Error('La imagen tiene ' + (this.file.size / 1000000) + 'MB y no puede superar las 5MB'))
        }
        const formData = new FormData()
        formData.append('file', this.file)
        return apiClient.post('/schools/' + idSchool + '/school-image',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
      } else {
        return new Promise((resolve, reject) => {
          resolve('noFile')
        })
      }
    },
    async save() {
      this.form.dv = this.dv
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        apiClient2.patch('/company/1', this.form).then(response => {
          this.$notification.success({
            message: 'Cambio guardado',
            description: 'La institución ha sido actualizada exitosamente.',
          })
          return this.saveImage(this.user.idSchool) // Se retorna promesa
        }).catch(error => {
          console.log(error)
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: error.response.data.msg,
          })
        })
      }
    },
  },
  watch: {
    'form.idDepartment': function(value) {
      apiClient2.get(`/departments/${value}/municipalities`).then(data => {
        this.municipalities = data.data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
        this.municipalities.unshift({ value: null, text: 'Seleccione una opción' })
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: error.response.data.msg,
        })
      })
    },
  },
}
</script>
